<!-- este componente se usa en la vista de la atencion medica -->

<template>
  <div class="my-3">

    <h6 class="col my-1 text-center">
      <strong>Tabla de Procedimientos clinicos de la atención</strong>
    </h6>

    <b-row>

      <b-col v-if="procedimientosList.length > 0">
        <b-table 
          :items="procedimientosList" 
          :fields="tableFields"
          class="text-center"
          responsive small
        >
          <template #cell(index)="data">
            {{ data.index + 1 }}
          </template>

          <template #cell(acciones)="data">
            <b-button
              variant="danger"
              size="sm"
              style="cursor: pointer"
              @click="removeItem(data.item.id)"
            >
              <font-awesome-icon
                icon="circle-xmark"
                style="color: rgb(255, 255, 255)"
              />
            </b-button>
          </template>
        </b-table>
      </b-col>
    </b-row>

  </div>
</template>

<script>
export default {
  name: "ProcedimientosList",

  props: {
    value: {
      type: Array,
      required: true
    },

    onlyView: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      procedimientosList: this.value
    }
  },

  methods: {
    removeItem() {}
  },

  computed: {
    tableFields(){
      const baseFields = [
        { 
          key: "index", 
          label: "N°", 
          thClass: "text-center", 
          tdClass: "text-center" 
        },
        { 
          key: "procedimiento.descripcion", 
          label: "Procedimiento", 
          thClass: "text-center",
          tdClass: "text-left"
        },
        { 
          key: "noas400",  
          label: "# Orden As400",  
          thClass: "text-center",
        },

        { 
          key: "motivoSolicitud",  
          label: "Motivo",  
          thClass: "text-center",
        },
        { 
          key: "resumenClinico",  
          label: "Resumen Clinico",  
          thClass: "text-center",
        },
      ];


      if (this.onlyView) return baseFields;

      return [
        ...baseFields, 
        {
          key     : "acciones",
          label   : "acciones",
          sortable: true,
          thClass : "text-center",
          tdClass : "text-right",
        }
      ];
    }
  }

}
</script>
